import React from 'react';

const WideRowComponent = ({ children }) => {
  return (
    <div
      style={{
        marginLeft: '50%',
        transform: ' translateX(-50%)',
        width: '100vw',
      }}
    >
      {children}
    </div>
  );
};

export { WideRowComponent };
